let colors = {
    primary: '#845e5d',
    secondary: '#ab9192',
    tertiary: '#c6b6b1',
    fourthary: '#d4cec9',
    black: '#000',
    white: '#FEFDFD'
}

export { colors };